import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, Mail, HelpCircle, MessageSquare, FileText, Shield } from 'lucide-react';
import { AuthContext } from '../App';
import FaqDrawer from './FaqDrawer';
import SurveyModal from './SurveyModal';

export default function Footer() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  // Check if user is individual (logged in and not a business)
  const isIndividual = user && !user.is_business;

  return (
    <footer className="mt-20" style={{ backgroundColor: 'var(--fy-text-primary)', borderTop: '1px solid var(--fy-border-subtle)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-2xl font-black mb-4" style={{ fontFamily: 'Outfit', color: 'var(--fy-background-primary)' }}>LikeKind</h3>
            <p className="text-sm" style={{ color: 'var(--fy-text-disabled)' }}>
              Connecting communities and building relationships through shared interests.
            </p>
            
            {/* Individual-only links */}
            {isIndividual && (
              <div className="mt-4 pt-4 space-y-2" style={{ borderTop: '1px solid var(--fy-text-secondary)' }}>
                <FaqDrawer 
                  trigger={
                    <button className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity" style={{ color: 'var(--fy-text-disabled)' }}>
                      <HelpCircle className="w-4 h-4" />
                      How LikeKind Works
                    </button>
                  }
                />
                <SurveyModal 
                  trigger={
                    <button className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity" style={{ color: 'var(--fy-text-disabled)' }}>
                      <MessageSquare className="w-4 h-4" />
                      Share Your Experience
                    </button>
                  }
                />
              </div>
            )}
          </div>

          <div>
            <h4 className="font-bold mb-4" style={{ color: 'var(--fy-background-primary)' }}>For Businesses</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/directory')}
                  className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--fy-text-disabled)' }}
                >
                  <Briefcase className="w-4 h-4" />
                  Business Directory
                </button>
              </li>
              {/* "Create Business Account" entry removed — /upgrade-business unrouted pre-deploy. */}
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4" style={{ color: 'var(--fy-background-primary)' }}>Legal</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/about-terms')}
                  className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--fy-text-disabled)' }}
                >
                  <FileText className="w-4 h-4" />
                  About & Terms
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/content-guidelines')}
                  className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--fy-text-disabled)' }}
                >
                  <Shield className="w-4 h-4" />
                  Content Guidelines
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/privacy')}
                  className="text-sm hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--fy-text-disabled)' }}
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4" style={{ color: 'var(--fy-background-primary)' }}>Support</h4>
            <ul className="space-y-2">
              <li>
                <a href="mailto:support@likekind.com" className="text-sm flex items-center gap-2 hover:opacity-80 transition-opacity" style={{ color: 'var(--fy-text-disabled)' }}>
                  <Mail className="w-4 h-4" />
                  support@likekind.com
                </a>
              </li>
              <li>
                <button
                  onClick={() => navigate('/support')}
                  className="text-sm hover:opacity-80 transition-opacity"
                  style={{ color: 'var(--fy-text-disabled)' }}
                >
                  Help Center
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 text-center" style={{ borderTop: '1px solid var(--fy-text-secondary)' }}>
          <p className="text-xs mb-2" style={{ color: 'var(--fy-text-disabled)' }}>
            Shared with friends. Not public.
          </p>
          <p className="text-sm" style={{ color: 'var(--fy-text-disabled)' }}>
            © {new Date().getFullYear()} <strong>LikeKind™</strong> - All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
